import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { withLocale } from 'utils/hocs';
import { alertState } from 'utils/recoil/snackbar';
import { returnKlavyoLang } from 'utils/globals';
import { pushOptinSubmitEventToDatalayer } from 'utils/dataLayer/optinSubmitEvent';
import { Form } from '../../../UI/Forms/Form/form';
import NoozApi from '../../../../services/NoozApi';

export const CrmForm = withLocale(({ locale, form }) => {
  const { successLabels, errorLabels, metaData } = form;
  const [alert, setAlert] = useRecoilState(alertState);

  const lang = returnKlavyoLang(locale[0]);
  const tag = metaData && metaData.tag;
  const event = metaData && metaData.event;
  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmit = (data) => {
    const formatedData = { ...data, lang, tag };

    setIsLoading(true);

    NoozApi.post('/web/klavyo', formatedData)
      .then((response) => {
        pushOptinSubmitEventToDatalayer(event);
        setIsLoading(false);
        if (response.data.responseType === 1) {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: successLabels[0]?.text,
          });
        } else if (response.data.responseType === 0) {
          setAlert({
            ...alert,
            show: true,
            type: 'error',
            title: errorLabels[0]?.text,
          });
        }
      })
      .catch(({ response }) => {
        setIsLoading(false);
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${errorLabels[0]?.text} : ${response?.statusText}`,
        });
      });
  };

  return (
    <Form
      {...form}
      isLoading={isLoading}
      onSubmit={handleOnSubmit}
    />
  );
});
